<template>
  <div>
    <top-bar heading="Edit Stream"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3" v-if="loaded">

      <b-card class="p-3 mb-3">
        <div class="row">
          <div class="col-12">
            <h3>STREAM DETAILS</h3>
          </div>
          <div class="col">
            <label>Stream Name</label>
            <input type="text" class="form-control input-title input-flat" placeholder="Stream Name.." v-model="stream.stream"/>
          </div>
          <div class="col">
            <label>Stream Status</label>
            <select class="form-control"
                    name="stream_published"
                    id="stream_published"
                    v-model="stream.published"
                    :disabled="!$auth.check('super_admin')">
              <option :value="0">Draft</option>
              <option :value="1">Published</option>
            </select>
          </div>
          <div class="col-12 mt-3">
            <loading-button :loading="loading" block @submit="saveStream">Save Stream</loading-button>
          </div>
        </div>
      </b-card>


      <edit-streams-cards v-model="stream.courses" :stream-id="stream.id"></edit-streams-cards>



    </div>
  </div>
</template>

<script>
import EditStreamsCards from '../../components/EditStreamsCards';
import sortBy from 'lodash-es/sortBy';
export default {
  name: 'EditStream',
  components: {EditStreamsCards},
  data () {
    return {
      loaded: false,
      stream: {},
      coreUnits: [],
      electiveUnits: [],
      subElectiveUnits: [],
      loading: false
    };
  },
  methods: {
    getStream () {
      this.loaded = false;
      this.axios.get('/course_streams/' + this.id, {params: {includes: 'courses'}}).then(rsp => {
        this.stream = rsp.data;
        this.stream.courses = sortBy(rsp.data.courses, unit => unit.pivot.course_order);
        this.loaded = true;
      });
    },
    saveStream () {
      this.loading = true;
      this.axios.put('/course_streams/' + this.id, this.stream).then(() => {
        this.getStream();
        this.$snotify.success('Stream Updated');
        this.loading = false;
      });
    }
  },
  computed: {
    units () {
      return this.$store.state.units;
    }
  },
  mounted () {
    this.getStream();
    this.$store.dispatch('LOAD_UNITS', this);
  },
  metaInfo: {
    title: 'Edit Stream'
  },
  props: ['id']
};
</script>
